export default __webpack_public_path__ + "static/0565companyoverview-b98d1021cbbf4517b9a372c087252aef.jpg";